/**
 * Custom hook for formatting prices based on region.
 */
const usePriceFormatter = () => {
    /**
     * Formats a given amount into a price string based on the specified region.
     *
     * @param {string} region - Region to determine the currency format ("USA", "CAN", etc.)
     * @param {number} amount - Numeric value to format
     * @param {number} [minimumFractionDigits=2] - Optional override for decimal precision (default is 2)
     * @returns {string} - Formatted price string (e.g., "$1,234.56 USD" or "CAD $ 1,234.56")
     */
    const formatPriceByRegion = (region = "USA", amount = 0, minimumFractionDigits = 2) => {
        const factor = Math.pow(10, minimumFractionDigits);
        const roundedAmount = Math.round(amount * factor) / factor;

        const formattedPrice = roundedAmount.toLocaleString("en-US", {
            minimumFractionDigits,
        });

        switch (region) {
            case "CAN":
            case "CA":
                return `CAD $ ${formattedPrice}`;
            default:
                return `$${formattedPrice} USD`;
        }
    };

    return {
        formatPriceByRegion,
    };
};

export default usePriceFormatter;
